<!-- app/javascript/dashboard/components-next/sidebar/LabelLeaf.vue -->
<!-- CUSTOM: bocket-multi-label-filter -->
<script setup>
defineProps({
  label: { type: String, required: true },
  // eslint-disable-next-line vue/no-unused-properties -- recibido por simetría de API: SidebarGroupLeaf pasa `active` a todos los leafs, pero el estilo activo lo aplica ese wrapper padre, no este componente
  active: { type: Boolean, default: false },
  labelColor: { type: String, required: true },
  isSelected: { type: Boolean, default: false },
});

const emit = defineEmits(['checkboxToggle']);

const onCheckboxClick = event => {
  event.stopPropagation();
  event.preventDefault();
  emit('checkboxToggle');
};
</script>

<template>
  <!-- Checkbox: visible siempre si isSelected, solo en hover si no -->
  <span
    class="size-4 flex-shrink-0 grid place-content-center transition-opacity duration-100 cursor-pointer"
    :class="isSelected ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'"
    @click="onCheckboxClick"
  >
    <span
      class="size-3 rounded border flex items-center justify-center"
      :class="isSelected ? 'bg-n-brand border-n-brand' : 'border-n-slate-6'"
    >
      <!-- eslint-disable-next-line vue/no-bare-strings-in-template -- glifo decorativo, no texto de usuario -->
      <span v-if="isSelected" class="text-[8px] text-white">✓</span>
    </span>
  </span>
  <!-- Colored dot (igual que el icon actual) -->
  <span
    class="size-[8px] rounded-sm flex-shrink-0"
    :style="{ backgroundColor: labelColor }"
  />
  <!-- Label name -->
  <div class="flex-1 truncate min-w-0 text-sm">{{ label }}</div>
</template>
